/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Tools_RejectedInputs */



/**
* | output |
* | --- |
* | "The server refused the tool-calling test. The model works without tools." |
*
* @param {Private_Models_Hint_Tools_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_tools_rejected = /** @type {((inputs?: Private_Models_Hint_Tools_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Tools_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server hat den Tool-Test abgelehnt. Ohne Tools funktioniert das Modell.")
	return /** @type {LocalizedString} */ ("The server refused the tool-calling test. The model works without tools.")
});